<template>
  <div class="page addTest">
    <div class="card" v-for="(item,i) in orderList" :key="i" v-if="orderList.length>0">
      <div class="icon">
        <img src="@/assets/icon/innerSix.png" />
      </div>
      <div class="content">
        <p class="project">{{ item.projectName }}</p>
        <p class="time">
          {{ moment(item.startDate).format("YYYY/MM/DD") }}
          {{ time[item.timeType] }}
          {{ item.startTime }}
        </p>
        <!-- <p class="timeRange">{{ item.startTime }}</p> -->
        <van-tag plain v-if="+item.isOrder == 1" size="large"  type="success">已预约</van-tag>
        <!-- <span class="detail" @click="forDetail(item)">查看详情</span> -->
      </div>
      <div class="btn">
        <span v-if="+item.isOrder == 0" class="detail" @click="Onadd(item)">报名</span>
        <span v-if="+item.isOrder == 1" class="cancel" @click="forCancel(item)">取消预约</span>
      </div>
    
      <!-- <div class="status" :style="{ backgroundColor: backgroundColor[item.status] }">
        <p>{{ status[item.status] }}</p>
      </div> -->
    </div>
    <van-empty
      v-if="orderList.length==0"
      image-size="80"
      description="暂无预约测试"
      />



    <van-popup class="projectInfo" v-model="testTips">
      <div class="icon">
        <img :src="require('@/assets/background/subscribeLogTips.png')" />
      </div>
      <div class="content">
        <p class="status">{{ status[clickInfo.status] }}</p>
        <p class="line"></p>
        <p class="text" v-if="+clickInfo.status === 1">
          您已完成 {{ time[clickInfo.timeType] }} {{ clickInfo.startTime }}的
          {{ clickInfo.projectName }}的测试。
        </p>
        <p class="text" v-if="+clickInfo.status === 2">
          您预约的 {{ moment(clickInfo.day).format("YYYY年MM月DD日") }}
          {{ time[clickInfo.timeType] }} {{ clickInfo.time }} 的
          {{ clickInfo.projectName }} 测试已过期。
        </p>
        <p class="text" v-if="+clickInfo.status === 3">
          您预约的{{ moment(clickInfo.day).format("YYYY年MM月DD日") }}
          {{ time[clickInfo.timeType] }}
          {{ clickInfo.time }}的
          {{ clickInfo.projectName }} 测试即将开始，请提前20分钟到达。
        </p>
        <Describe />
      </div>
    </van-popup>
  </div>
</template>

<script>
import Describe from './describe'
import { Dialog } from 'vant'
import moment from 'moment'
import { checkOrder,getOrderList,getDelectOrder,orderBySnCode,unOrderBySnCode } from "@/api/appointment.js";
import { getChildInfoList} from "@/api/studentBind.js";
export default {
  name: 'addTest',
  components: { Describe },
  data () {
    return {
      testTips: false,
      userInfo: {},
      status: {
        1: '已测试',
        2: '已过期',
        3: '未测试'
      },
   
      backgroundColor: {
        1: '#f7b331',
        2: '#ff7079',
        3: '#c7c7c7'
      },
      time: ['上午', '下午', '晚上'],
      clickInfo: {},
      orderList:[]
    }
  },
  created () {
    this.init()
  },
  methods: {
    Onadd(item){
 this.$dialog
        .alert({
          message: '是否确认报名?',
          showCancelButton: true
        })
        .then(() => {
            orderBySnCode({
                  snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
                ...item
            }).then(Res=>{
            this.$notify({ type: "success", message: '报名成功！' });
            this.init()
            })
        })
    },
    moment,
    forDetail (item) {
      this.clickInfo = item
      this.testTips = true
    },

    init(){
      this.getOrderList()

    },
   getOrderList(){
        getOrderList({
            snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
          }).then(res=>{
            res.data.data?.forEach(el=>{
                if (el.projectId == 'ClassOut') {
                    el.projectName = '室外项目'
                }else{
                    el.projectName = '室内项目'
                }
            })
            this.orderList = res.data.data||[]
         
          })
    },
    // getLog () {
    //   getOrderList({
    //     activityOrder: {
    //       snCode: this.userInfo.snCode
    //     }
    //   }).then(({ data }) => {
    //     this.orderList = data
    //   })
    // },
    forCancel (item) {
      this.$dialog
        .alert({
          message: '是否确认取消报名?',
          showCancelButton: true
        })
        .then(() => {
            unOrderBySnCode({
                  snCode:this.$route.query.snCode,
            schoolCode:this.$route.query.schoolCode,
                ...item
            }).then(Res=>{
            this.$notify({ type: "success", message: '取消报名成功！' });
            this.init()
            })
        })
       
      
    }
  }
}
</script>

<style lang="less" scoped>
.addTest {
  img {
    width: 100%;
    height: 100%;
  }

  .card {
    display: flex;
    position: relative;
    width: 90%;
    height: 120px;
    padding-top: 10px;
    margin-top: 15px;
    margin-left: 5%;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 3px 6px 20px -11px rgba(09, 18, 5f, 0.3);

    div {
      display: inline-block;
    }

    .icon {
      width: 60px;
      height: 60px;
      margin-left: 10px;
    }

    .content {
      margin-left: 10px;
      p{
        margin: 0;
        padding: 0;
      }
      .project {
        font-size: 20px;
        margin-bottom: 5px;
      }

      .time {
        font-size: 14px;
        color: #bccad4;
        margin-bottom: 10px;
      }

      .timeRange {
        text-align: left;
        border-radius: 20px;
        margin-top: 10px;
        margin-bottom: 10px;
        color: #bccad4;
        font-size: 12px;
      }

      .cancel {
        margin-left: 20px;
        color: #7f8083;
        border: 1px solid #7f8083;
        border-radius: 20px;
        padding: 5px 10px;
        font-size: 10px;
      }

   
    }
    .btn{
        display: flex;
        align-items: flex-end;
      position: absolute;
      bottom: 15px;
      right: 0;
      width: 70px;
      height: 100px;
      border-radius: 0 20px 20px 0;
   
   .detail {
        color: #ee0a24;
        border: 1px solid #ee0a24;
        border-radius: 20px;
        padding: 5px 10px;
        font-size: 10px;
      }
      .cancel {
        color: #7f8083;
        border: 1px solid #7f8083;
        border-radius: 20px;
        padding: 5px 10px;
        font-size: 10px;
      }
    }
    .status {
      position: absolute;
      top: 0;
      right: 0;
      width: 50px;
      height: 130px;
      border-radius: 0 20px 20px 0;

      p {
        width: 20px;
        font-size: 12px;
        font-weight: 700;
        color: #fff;
        margin: 35px 0 0 20px;
      }
    }
  }

  .projectInfo {
    width: 310px;
    height: 370px;
    border-radius: 30px;

    .icon {
      position: relative;
      height: 95%;
    }

    .content {
      position: absolute;
      top: 20px;
      left: 15px;
      margin-right: 15px;

      .line {
        width: 40px;
        height: 5px;
        border-radius: 20px;
        margin-top: 10px;
        background: linear-gradient(to right, #4facfe, #00f2fe);
      }

      .text {
        font-size: 14px;
        font-weight: 600;
        margin-top: 25px;
      }
    }
  }
}
</style>
